module.exports = __webpack_public_path__ + "img/graph.2825a86e.svg";